<template>
    <tr class="v-row-group__header amber lighten-4">
        <th><strong>{{ task.name }}</strong></th>
        <th>{{ task.description }}</th>
        <th>{{ task.date_start | date }}</th>
        <th>{{ task.date_end | date }}</th>
        <th>
            <sal-progressbar :small="true" :value="taskInfo.progress"></sal-progressbar>
        </th>
        <th>
            <nice-time-editor v-if="permissions.includes('view_sub_tasks_resources_hours')" :disabled="true" :value="taskInfo.hours"></nice-time-editor>
            <span v-else>-</span>
        </th>
        <td>
            <nice-time-editor v-if="permissions.includes('view_sub_tasks_resources_hours_real')" :disabled="true" :value="taskInfo.hours_real"></nice-time-editor>
            <span v-else>-</span>
        </td>
        <td>
            <template v-if="task.active"><v-icon color="success">check_circle</v-icon></template>
            <template v-else><v-icon color="error">cancel</v-icon></template>
        </td>
        <th>
            <template v-if="item.taskInfo && permissions.includes('view_sub_tasks_resources_price')">
                <span class="blue--text" v-if="item.taskInfo.priceDiff == 0">
                    {{ item.taskInfo.realPrice | euro }}
                </span>
                <span class="red--text" v-else-if="item.taskInfo.priceDiff > 0">
                    {{ item.taskInfo.realPrice | euro }} (+{{ item.taskInfo.priceDiff | euro }})
                </span>
                <span class="green--text" v-else>
                    {{ item.taskInfo.realPrice | euro }} ({{ item.taskInfo.priceDiff | euro }})
                </span>
            </template>
            <template v-else>-</template>
        </th>
        <th class="text-right">
            <template v-if="!disabled">
                <v-btn small icon color="warning" @click="$emit('edit', task)"
                    v-bind="{ loading }"><v-icon>edit</v-icon></v-btn>
                <v-btn small icon color="teal" @click="$emit('duplicateTask', task)"
                    v-bind="{ loading }"><v-icon>content_copy</v-icon></v-btn>
                <v-btn small icon color="success" @click="$emit('addSubtask', task)"
                    v-bind="{ loading }"><v-icon>playlist_add</v-icon></v-btn>
            </template>
        </th>
    </tr>
</template>
<script>
export default {
    props: {
        group: { required: true, type: String },
        items: { required: true, type: Array },
        disabled: { default: false },
        loading: { default: false },
        permissions: {type:Array, default:[]}
    },
    computed: {
        item() {
            return this.items && this.items[0];
        },
        task() {
            return this.item && this.item.task;
        },
        taskInfo() {
            return this.item.taskInfo;
        },
    }
}
</script>